import './index.scss'
import '../../assets/scripts/jquery.mousewheel'

$(document).ready(function(){
  getArticleH()
  $('.ny-leaf-cont').addClass('show')
  let navLeft = $('.pro-main-subnav a.active').offset().left - 20
  $('.pro-main-subnav').scrollLeft(navLeft)

  if($('.text-accordion').length > 0){
    $('.text-accordion .accordion-item').eq(0).addClass('active').find('.item-desc').slideDown(200)

    $('.text-accordion .accordion-item .item-title').on('click',function(){
      let $parentsEl = $(this).parents('.accordion-item')
      console.log($parentsEl)
      if($parentsEl.hasClass('active')){
        $parentsEl.removeClass('active').find('.item-desc').slideUp(200)
      }else{
        $parentsEl.addClass('active').find('.item-desc').slideDown(200)
        $parentsEl.siblings().removeClass('active').find('.item-desc').slideUp(200)
      }
    })
  }

  if($('.text-tab').length > 0){
    $('.text-tab .tab-link>div').eq(0).addClass('active')
    $('.text-tab .tab-text>div').eq(0).show()

    $('.text-tab .tab-link>div').hover(function(){
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      $('.text-tab .tab-text>div').eq(index).show().siblings().hide()
    })
  }

  if($('.cont2 .right ul li').length > 6 && $('.cont2 .right ul li').length <= 8){
    $('.cont2 .right ul').addClass('line-4')
  }else if($('.cont2 .right ul li').length > 8){
    $('.cont2 .right ul').addClass('line-5')
  }

  $('.open-popup').on('click',function(){
    $('.pro-article-popup').fadeIn(200)
  })
  $('.popup-close,.pro-article-popup .popup-mask').on('click',function(){
    $('.pro-article-popup').fadeOut(200)
  })
})
$(window).resize(function(){
  getArticleH()
})

function getArticleH(){
  if($(window).width()>1024){
    let articleH = $(window).height() - $('.article-cont .article-title').outerHeight() - 80
    $('.article-cont .article').css('height', articleH + 'px')
  }
}


$('body').mousewheel(function (event,dat) {
  let footerH = $('.fixed-footer').outerHeight()
  if($(window).width() > 1024){
    let scroH = $('.article').scrollTop(); //滚动高度
    let viewH = Math.floor($('.article').outerHeight()); //可见高度
    let contentH = Math.floor($('.article .cont').outerHeight()); //内容高度
    if( contentH-(scroH + viewH) < 150){
      $('.scroll-icon').fadeOut(200)
    }else{
      $('.scroll-icon').fadeIn(200)
    }
    if(dat == 1){
      // console.log('上翻隐藏footer')
      $('.fixed-footer').removeClass('show')
      $('.footer-tran').css('transform','none')
    }else if(dat == -1){
      // console.log('下翻显示footer')
      if(contentH > viewH){
        if( contentH-(scroH + viewH) < 3){
          if(!$('.fixed-footer').hasClass('show')){
            $('.fixed-footer').addClass('show')
            $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
          }
        }
        
      }else{
        if(!$('.fixed-footer').hasClass('show')){
          $('.fixed-footer').addClass('show')
          $('.footer-tran').css('transform','translateY('+ -footerH +'px)')
        }
      }
    }
  }
})

// 叶子效果跟随鼠标位移效果
var viewH = $(window).height()
var vieww = $(window).width()
$('body').mousemove(function(e){
  $('.ny-leaf-cont .leaf6').css('transform','translate3d('+(e.pageX-vieww/2)/50+'px,'+(e.pageY-viewH/2)/50+'px,0)')
  $('.ny-leaf-cont .leaf5').css('transform','translate3d('+-(e.pageX-vieww/2)/40+'px,'+-(e.pageY-viewH/2)/40+'px,0)')
})
